<div style="font-family: sans-serif;">


  <!-- Title -->
  <div class="text-center py-8 sm:py-10">
    <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 tracking-wide" style="font-family: 'Roboto Slab', serif;">Contact Us</h1>
    <div class="flex items-center justify-center gap-2 mt-3">
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
    </div>
  </div>

  <!-- Content -->
  <div class="max-w-[1100px] mx-auto px-4 sm:px-6 pb-12 sm:pb-16">
    <div class="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">

      <!-- LEFT: Contact Info (3 cols) -->
      <div class="lg:col-span-3 space-y-10">

        <!-- Row 1: Corporate Office + Individual Orders -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">

          <!-- Corporate Office -->
          <div>
            <h3 class="text-lg font-bold text-[#600b0b] mb-1" style="font-family: 'Roboto Slab', serif;">Corporate Office</h3>
            <div class="flex items-center gap-2 mt-2 mb-3">
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
            </div>
            <div class="flex items-start gap-2 text-sm text-gray-600">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0 mt-0.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              <span>8/17, Ground Floor, Sarvapriya Vihar, New Delhi -110016</span>
            </div>
          </div>

          <!-- For Individual Orders -->
          <div>
            <h3 class="text-lg font-bold text-[#600b0b] mb-1" style="font-family: 'Roboto Slab', serif;">For Individual Orders</h3>
            <div class="flex items-center gap-2 mt-2 mb-3">
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
            </div>
            <p class="text-sm text-gray-600 mb-3">Contact us to customize your framing from Single photo frame to multiple set of photo frames, to Collage picture frame to Table photo frame and many more.</p>
            <div class="space-y-1.5 text-sm text-gray-600">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                <span>+91-9810223204</span>
              </div>
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <span>9:30AM to 7:00PM (Monday to Saturday)</span>
              </div>
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <a href="mailto:support@mahattaart.com" class="text-[#600b0b] hover:underline">support&#64;mahattaart.com</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Row 2: Corporate Orders + Art Advisory -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-8">

          <!-- For Corporate Orders -->
          <div>
            <h3 class="text-lg font-bold text-[#600b0b] mb-1" style="font-family: 'Roboto Slab', serif;">For Corporate Orders</h3>
            <div class="flex items-center gap-2 mt-2 mb-3">
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
            </div>
            <div class="space-y-1.5 text-sm text-gray-600">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                <span>+91-8448997284</span>
              </div>
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <span>9:30AM to 7:00PM (Monday to Saturday)</span>
              </div>
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <a href="mailto:corporatesales@mahattaart.com" class="text-[#600b0b] hover:underline">corporatesales&#64;mahattaart.com</a>
              </div>
            </div>
          </div>

          <!-- For Art Advisory Services -->
          <div>
            <h3 class="text-lg font-bold text-[#600b0b] mb-1" style="font-family: 'Roboto Slab', serif;">For Art Advisory Services</h3>
            <div class="flex items-center gap-2 mt-2 mb-3">
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
              <div class="w-6 h-[2px] bg-[#600b0b]"></div>
            </div>
            <div class="space-y-1.5 text-sm text-gray-600">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                <span>+91-9810223204</span>
              </div>
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                <span>9:30AM to 7:00PM (Monday to Saturday)</span>
              </div>
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="2" class="shrink-0"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <a href="mailto:artadvisory@mahattart.com" class="text-[#600b0b] hover:underline">artadvisory&#64;mahattart.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT: Contact Form (2 cols) -->
      <div class="lg:col-span-2">
        <div class="bg-[#faf5f0] rounded-lg p-6 sm:p-8">
          <h3 class="text-xl font-bold text-gray-900 text-center mb-1" style="font-family: 'Roboto Slab', serif;">Fill The Form!</h3>
          <div class="flex items-center justify-center gap-2 mb-6">
            <div class="w-6 h-[2px] bg-[#600b0b]"></div>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
            <div class="w-6 h-[2px] bg-[#600b0b]"></div>
          </div>

          <div class="space-y-4">
            <input [(ngModel)]="form.name" type="text" placeholder="Name *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />
            <input [(ngModel)]="form.email" type="email" placeholder="Email *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />
            <input [(ngModel)]="form.contact" type="tel" maxlength="10" placeholder="Contact *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors placeholder:text-gray-400" />
            <textarea [(ngModel)]="form.query" rows="3" placeholder="Query *"
              class="w-full border-b border-gray-300 bg-transparent px-1 py-2.5 text-sm outline-none focus:border-[#600b0b] transition-colors resize-none placeholder:text-gray-400"></textarea>
          </div>

          <p *ngIf="error" class="text-xs text-red-500 mt-3">{{ error }}</p>
          <p *ngIf="success" class="text-xs text-green-600 mt-3 font-semibold">Thank you! We'll get back to you soon.</p>

          <button (click)="submit()" [disabled]="loading"
            class="mt-6 bg-[#600b0b] text-white px-8 py-3 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#8c1c1c] transition-colors disabled:opacity-50">
            {{ loading ? 'Sending...' : 'Send Query' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
